
export default {
  data() {
    return {
      isExpanded: false, 
    };
  },
  methods: {
    toggleContent() {
      this.isExpanded = !this.isExpanded; 
    },
  },
};
